import { useState } from 'react';
import '../styles/Home.css';

const Sponsors = () => {

  return (

    <div className="container">

      <div>

      </div>

      <div className="row">
        <h4 className="center-align"><b >MCIA Sponsors for 2025</b></h4>
        <h5 className="center-align">MCIA thanks all our sponsors for their continued support.</h5>
      </div>

      <div><hr class="hr-line"></hr></div>

      <div>
        <h2 className="fbt-title"><img src="/images/sponsors/Bloom.png" alt="" width="40%" className="rounded" />  </h2>
        <p >&nbsp;</p>
        <h5 className="center-align"><b >Diamond Sponsor</b></h5>
      </div>

      <p >&nbsp;</p>
      <div><hr class="hr-line"></hr></div>

      <div>
        <h2 className="fbt-title"><img src="/images/sponsors/Bloom-Bazaar.png" alt="" width="60%" className="rounded" />  </h2>
        <p >&nbsp;</p>
        <h5 className="center-align"><b >Silver Sponsor</b></h5>
      </div>

      <div>
        <h2 className="fbt-title"><img src="/images/sponsors/GNR.png" alt="" width="60%" className="rounded" />  </h2>
        <p >&nbsp;</p>
        <h5 className="center-align"><b >Silver Sponsor</b></h5>
      </div>

      <p >&nbsp;</p>
      <div><hr class="hr-line"></hr></div>

      <div>
        <h2 className="fbt-title"><img src="/images/sponsors/Akruti.png" alt="" width="40%" className="rounded" />  </h2>
        <p >&nbsp;</p>
        <h5 className="center-align"><b >Bronze Sponsor</b></h5>
      </div>

      <p >&nbsp;</p>
      <div><hr class="hr-line"></hr></div>

      <div>
        <h2 className="fbt-title"><img src="/images/sponsors/Park.png" alt="" width="40%" className="rounded" />  </h2>
        <p >&nbsp;</p>
        <h5 className="center-align"><b >Hospitality  Partner</b></h5>
      </div>

      <p >&nbsp;</p>
      <div><hr class="hr-line"></hr></div>

      <div>
        <h2 className="fbt-title"><img src="/images/sponsors/WokToBowl.png" alt="" width="40%" className="rounded" />  </h2>
        <p >&nbsp;</p>
        <h5 className="center-align"><b >Badminton & Pickleball Sponsor</b></h5>
      </div>

      <p >&nbsp;</p>
      <div><hr class="hr-line"></hr></div>

      <div>
        <h2 className="fbt-title"><img src="/images/sponsors/signature.jpg" alt="" width="40%" className="rounded" />  </h2>
        <p >&nbsp;</p>
        <h5 className="center-align"><b >Title sponsors for Volleyball and Throwball Tournament</b></h5>
      </div>

      <p >&nbsp;</p>
      <div><hr class="hr-line"></hr></div>

    </div>



  );
}
export default Sponsors;
